export const formatISODate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth() devuelve un índice basado en cero
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
